import React from 'react';
import { useSearchParams } from 'react-router-dom';
import PreAttendance from './PreAttendance';
import EventAttendance from './EventAttendance';

const ConfirmAttendance = () => {
    const [searchParams] = useSearchParams();
    const type = searchParams.get('type') || searchParams.get('record_type');

    if (type === 'asistire' || type === 'pre_attendance' || type === 'asistire_al_evento') {
        return <PreAttendance />;
    }

    if (type === 'event' || type === 'attendance' || type === 'asistencia_en_el_evento') {
        return <EventAttendance />;
    }

    // Default to PreAttendance if accessed pre-login, or EventAttendance if user is logged in
    const token = localStorage.getItem('token');
    if (token) {
        return <EventAttendance />;
    }

    return <PreAttendance />;
};

export default ConfirmAttendance;
